"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationContext = void 0;
const react_1 = require("react");
exports.OrganizationContext = (0, react_1.createContext)({});
